import * as React from "react";
import styled, { css } from "styled-components";
import { select, Colorable, Color } from "@hubper/theme";
import TextComponent, { TextProps } from "../../elements/Text";
import DeleteButton from "./DeleteButton";

const ellipsisStyle = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Base = styled.div<Colorable & { multiline?: boolean }>`
  background-color: ${select.findColor};
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  box-sizing: border-box;

  ${p =>
    p.multiline
      ? css`
          min-height: 22px;
        `
      : css`
          height: 22px;
        `}
`;

const Text = styled(TextComponent)<{ multiline?: boolean }>`
  position: relative;
  top: -1px;
  display: inline-block;
  padding: ${select.space(0)} ${select.space(2)};
  ${p => !p.multiline && ellipsisStyle}
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  text: string;
  beforeText?: React.ReactNode;
  afterText?: React.ReactNode;
  multiline?: boolean;
  textProps?: TextProps;
  onDelete?: () => void;
} & Colorable;

function Tag(
  {
    style,
    className,
    text,
    afterText,
    beforeText,
    multiline,
    textProps,
    onDelete,
    c = ["grey", 1]
  }: Props,
  ref: any
) {
  let fontColor: Color | string = "white";
  if (Array.isArray(c)) {
    if (c[0] === "grey") {
      if (c[1] >= 7) {
        fontColor = ["grey", 1];
      } else {
        fontColor = ["grey", 7];
      }
    } else {
      fontColor = [c[0], 0];
    }
  }

  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      c={c}
      multiline={multiline}
    >
      {beforeText}
      <Text
        fw="bold"
        fs={-2}
        c={fontColor}
        {...textProps}
        multiline={multiline}
      >
        {text}
      </Text>
      {afterText}
      {onDelete && (
        <DeleteButton onClick={onDelete} c={c} style={{ marginRight: 4 }} />
      )}
    </Base>
  );
}

export default React.forwardRef(Tag);
